import { network } from 'services/network';

export const getUserExtDomain = (params) => {
    return network.post('api/bo/getUserExtDomain', { username: params.username }).then((response) => {
        return response.data;
    });
};
